import React, { useEffect, useState } from "react"
import Chart from "react-apexcharts"
import { useSelector } from "react-redux"
import { isEmpty } from "lodash"

const AttendanceOverTime = () => {
  const { attendanceovertime } = useSelector(state => state.Dashboard)
  const [labels, setLabels] = useState([])
  const [seriesData, setSeriesData] = useState([])

  useEffect(() => {
    if (!isEmpty(attendanceovertime)) {
      const data = attendanceovertime[0]
      const lbls = data.Labels ? data.Labels.split(",") : []
      const vals = data.Series
        ? data.Series.split(",").map(num => parseInt(num.trim(), 10))
        : []
      setLabels(lbls)
      setSeriesData(vals)
    }
  }, [attendanceovertime])

  const options = {
    chart: {
      type: "line",
      height: 300,
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: labels,
      labels: {
        rotate: -45,
        style: {
          fontSize: "12px",
        },
      },
    },
    yaxis: {
      title: {
        text: "Cumulative Attendees",
      },
      labels: {
        formatter: val => Math.round(val),
      },
    },
    tooltip: {
      y: {
        formatter: val => `${val} Attendees`,
      },
    },
    colors: ["#FEB019"],
    grid: {
      borderColor: "#f1f1f1",
    },
  }

  const series = [
    {
      name: "Attendance Over Time",
      data: seriesData,
    },
  ]

  return <Chart options={options} series={series} type="line" height={300} />
}

export default AttendanceOverTime
